import { IngredientWithDetails } from '../types/ingredient-types';
import { IngredientAllergenHistory } from './ingredient-allergen-history';
import { IngredientAllergens } from './ingredient-allergens';

interface IngredientAllergenProps {
  ingredient: IngredientWithDetails;
  isEditable: boolean;
}

export function IngredientAllergenTab({
  ingredient,
  isEditable,
}: IngredientAllergenProps) {
  return (
    <div className="pt-2">
      <IngredientAllergens ingredient={ingredient} isEditable={isEditable} />
      <IngredientAllergenHistory ingredientId={ingredient.id} />
    </div>
  );
}
